export default {
  trnslt: {
    paddingTop: '20px',
    width: '1000px',
    margin: '0 auto',
  },
  trnslNewDictRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  trnsltHeading2: {
    textTransform: 'uppercase',
    marginBottom: '20px',
  },
  trnsltRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
    maxHeight: '100px',
    overflow: 'hidden',

    '&:hover': {
      cursor: 'pointer',
      background: 'lightblue',
    },
  },
  trnsltSearch: {
    height: '50px',
    background: '#fff',
    fontSize: '18px',
    width: 'calc(100% - 24px)',
    marginBottom: '20px',
    paddingLeft: '20px',
  },
  trnsltRowDiv: {
    width: '30%',
  },
  trnsltModalInput: {
    width: '785px',
    height: '30px',
    paddingLeft: '10px',
    marginBottom: '20px',
  },
  trnsltModalHeading3: {
    marginBottom: '10px',
  },
  trnsltModalRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '20px',
  },
  trnsltModalRowTextarea: {
    width: '380px',
  },
  trnsltSuccess: {
    padding: '15px',
    color: '#3c763d',
    backgroundColor: '#dff0d8',
    borderColor: '#d6e9c6',
  },
  itemsTable: {
    background: '#fff',
  },
  itemRow: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#f4f4f4',
    },
  },
  trnsltNotFoundText: {
    marginBottom: '0',
  },
};
